import React, { Component } from 'react';
import Util from './Util.js';
import { withRouter } from 'react-router-dom';

class TopBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuIsShow: true,
      topbarClassName: "topbar"
    };
    this.navigateBack = this.navigateBack.bind(this);
    this.navigateTo = this.navigateTo.bind(this);
    this.findPreviousNodeById = this.findPreviousNodeById.bind(this);
    this.onHClickHideShowMenu = this.onHClickHideShowMenu.bind(this);
    this.header = null;
  }

  componentWillMount() {
  }

  onDownloadTrial() {
    dataLayer.push({ 'event': 'TrackEvent', 'eventCategory': 'Download Trail', 'eventAction': 'Download Trail', 'eventLabel': 'Download Trail' });
  }

  findPreviousNodeById(node, id) {
    let result = null;

    if (node.id) {
      if (node.id.toLowerCase() === id.toLowerCase()) {
        return result;
      }
      else {
        if (node.children) {
          for (let i = 0; i < node.children.length; i++) {
            if (node.children[i].id == id && i != 0) {
              result = node.children[i - 1];
            }
            else {
              result = this.findPreviousNodeById(node.children[i], id);
            }
            if (result) {
              Util.InActiveAll(node);
              result.active = true;
              return result;

            }
          }
        }

      }
    }
    return result;
  }

  findNextNodeById(node, id) {
    let result = null;

    if (node.id) {
      if (node.id.toLowerCase() === id.toLowerCase()) {
        return result;
      }
      else {
        if (node.children) {
          for (let i = 0; i < node.children.length; i++) {
            if (node.children[i].id == id && i != node.children.length - 1) {
              result = node.children[i + 1];
            }
            else {
              result = this.findNextNodeById(node.children[i], id);
            }
            if (result) {
              Util.InActiveAll(node);
              result.active = true;
              return result;

            }
          }
        }

      }
    }
    return result;
  }

  navigateBack() {
    var previousNode = this.findPreviousNodeById(this.props.treeData, this.props.currentPage.id);
    if (previousNode) {
      this.props.history.push(previousNode.id);
      this.props.onToggleClick(previousNode, false);
    }
  }

  navigateTo() {
    var nextNode = this.findNextNodeById(this.props.treeData, this.props.currentPage.id);
    if (nextNode) {
      this.props.history.push(nextNode.id);
      this.props.onToggleClick(nextNode, false);
    }
  }

  onHClickHideShowMenu() {
    this.state.menuIsShow = !this.state.menuIsShow;
    var topbarDiv = document.getElementById("topbarElement");
    if (this.state.menuIsShow) {
      this.state.topbarClassName = "topbar";
    } else {
      this.state.topbarClassName = "menuHide";
    }
    this.props.onHClickHideShowMenu();
  }

  onHanburgerClick(e) {
    var el = this.header;
    if (!el) {
      return;
    }
    if (el.getAttribute('data-menu-show')) {
      el.removeAttribute('data-menu-show');
      if (this.props.mobileMenuIsShow) {
        document.body.style.overflow = 'hidden';
      }
      else {
        document.body.style.overflow = 'auto';
      }
    } else {
      el.setAttribute('data-menu-show', 'true');
      document.body.style.overflow = 'hidden';
    }
  }

  onMobileTreeMenuClick() {
    var newState = !this.props.mobileMenuIsShow;
    this.props.onMobileSideStateChanged(newState);
  }

  getSvg(props) {
    const { color, width, height, size, className, kind } = props

    switch (kind) {
      case ('collapse'): return (<svg fill={color} height={height || size} width={width || size} onClick={() => this.onHClickHideShowMenu()} className={className} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M.79 3.586h18.385c.413 0 .79-.414.79-.793 0-.414-.412-.793-.79-.793H.79C.378 2 0 2.414 0 2.793c0 .38.412.793.79.793zm18.317 5.413H6.597c-.411 0-.79.413-.79.793 0 .413.413.793.79.793h12.51c.412 0 .79-.414.79-.793 0-.38-.31-.793-.79-.793zm.103 7.067H.928c-.413 0-.79.414-.79.793 0 .414.412.793.79.793H19.21c.412 0 .79-.414.79-.793 0-.413-.412-.793-.79-.793zM4.364 6.275L0 9.619l4.296 3.413.068-6.757z" /></svg>)
      case ('expand'): return (<svg fill={color} height={height || size} width={width || size} onClick={() => this.onHClickHideShowMenu()} className={className} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M.973 3.586h18.21c.409 0 .783-.414.783-.793 0-.414-.408-.793-.783-.793H.973c-.408 0-.782.414-.782.793 0 .38.408.793.782.793zm17.594 5.413H1.103C.528 8.999 0 9.412 0 9.792c0 .413.576.793 1.103.793h17.464c.576 0 1.104-.414 1.104-.793 0-.38-.432-.793-1.104-.793zm.65 7.067H1.11c-.409 0-.783.414-.783.793 0 .414.408.793.783.793h18.107c.409 0 .783-.414.783-.793 0-.413-.408-.793-.783-.793z" /></svg>)
      default: return null
    }
  }

  getVersionInfo(props) {
    const versionFileUrl = window.content_path + "api/info/version";
    var options = {
      method: 'GET'
    };

    fetch(versionFileUrl, options).then(function (response) {
      if (response.ok) {
        return response.text();
      }
    }).then(function (data) {
      try {
        props.i18n.version = data;
      } catch (err) {
      } finally {
      }
    }).catch(function (error) {
      console.log('There has been a problem getting the version: ' + error.message);
    });
  }

  TopBarCN(lang, logo, svgProps) {
    let props = this.props

    return (
      <div id="topbarElement" className="topbar" ref={el => this.header = el}>

        <div className="navigatorHead">
          <a className="headerLink" href={props.i18n.spreadServicesLink}>
            <img className="logo_en_US" src={logo} alt="GrapeCity" />
            <div className="logoText">{props.i18n.logoText}</div>
          </a>
        </div>

        <ul className="nav navbar-nav">
          <li><a target="_blank" href={props.i18n.aboutLink}>{props.i18n.aboutText}</a></li>
          <li><a target="_blank" className='cn-link' href={props.i18n.apiLink}>{props.i18n.apiText}</a></li>
          <li><a target="_blank" href={props.i18n.supportLink}>{props.i18n.supportText}</a></li>
          <li><a target="_blank" href={props.i18n.pricingLink}>{props.i18n.pricingText}</a></li>
          {(true && <li><a target="_blank" href={props.i18n.communityLink}>{props.i18n.communityText}</a></li>)}
          <li><a className="navbar-nav-btn" target="_blank" href={props.i18n.freeTrialLink}>{props.i18n.freeTrialText}</a></li>
        </ul>

        <div className="app-hanburger" onClick={this.onHanburgerClick.bind(this)}>
          <i className='menu-icon fa'></i>
        </div>

        <div className="navigatorBar">
          <div className='nav-flex' style={{ height: '100%' }}>
            <div onClick={() => this.onHClickHideShowMenu()} className='menu-icon-container'>
              {this.getSvg(svgProps)}
            </div>
            <BreadCrumb {...props} />
          </div>
          <div className='search-bar-container'>
            <div className="version">{props.i18n.version}</div>
            <div className="searchBarWrapper fa fa-search">
              <input type="text" className="searchBar" onChange={props.onSearch} />
            </div>
          </div>
          <div className="treemenu" onClick={this.onMobileTreeMenuClick.bind(this)}>
            <i className='treemenu-icon fa' data-isshow={props.mobileMenuIsShow}></i>
          </div>
        </div>
      </div>
    )
  }

  TopBarMescius(lang, logo, svgProps) {
    let isKr = lang == "ko-KR";
    let props = this.props;
    let pricing = isKr ? props.i18n.pricingLink : window.content_path.replace('/demos/', '/pricing')
    let download = isKr ? props.i18n.freeTrialLink : window.content_path.replace('/demos/', '/download/')
    let overview = isKr ? props.i18n.aboutLink : window.content_path.replace('/demos/', '/docs/online/overview.html')
    let apiDoc = isKr ? props.i18n.apiLink : window.content_path.replace('/demos/', '/docs/online/JavaAPIDocumentation.html')
    let productLogoLink = isKr ? window.content_path : window.content_path.replace('/demos/', '/')
    return (
      <div id="topbarElement">
        <div id="app-header">
          <div class="app-header gc-flex-none gc-flex gc-flex-middle react-root-element" style={{ justifyContent: "space-between" }}>
            <div class="container-fluid">
              <div class="row">
                <div class="col-4">
                  <div class="app-logo">
                    <a class="app-branding-logo" href={props.i18n.mesciusLink}>
                      <img class="app-branding-logo-mobile" src="https://cdn.mescius.io/sites/shared/logo/mescius-logomark-w.svg" />
                      <img src="https://cdn.mescius.io/sites/shared/logo/mescius-logo-w.svg" />
                    </a>
                    <div class="app-logo-divide"></div>
                    <a class="app-product-logo" href={productLogoLink}>
                      <img class="app-product-logo-mobile" src={window.content_path + "images/dsexcel.svg"} />
                      <img src={window.content_path + "images/dsexcel-long.svg"} />
                    </a>
                  </div>
                </div>
                <div class="col-8 gc-flex justify-content-end app-menu">
                  <div class="gc-flex header-group">
                    <div class="gc-flex gc-flex-middle app-menu-text_item app_menu-item" data-isselected="true">
                      <a href={window.content_path}>DEMOS</a>
                    </div>
                    <div class="gc-flex gc-flex-middle app-menu-text_item app_menu-item" data-isselected="false">
                      <a href={overview}>DOCS</a>
                    </div>
                    <div class="gc-flex gc-flex-middle app-menu-text_item app_menu-item" data-isselected="false">
                      <a href={apiDoc}>API</a>
                    </div>
                    <div class="gc-flex gc-flex-middle app-menu-text_item app_menu-item" data-isselected="false">
                      <a href={pricing}>{props.i18n.pricingText}</a>
                    </div>
                  </div>
                  <div class="gc-flex header-group">
                    <div class="gc-flex gc-flex-middle app-menu-btn_item app-download-btn">
                      <a href={download}>{props.i18n.freeTrialText}</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="app-hamburger" onClick={this.onHanburgerClick.bind(this)}>
              <i class="menu-icon fa"></i>
            </div>
            <div id="lvl0" style={{ display: "none" }}>Demos</div>
          </div>
        </div>

        <div className="navigatorBar">
          <div className='nav-flex' style={{ height: '100%' }}>
            <div onClick={() => this.onHClickHideShowMenu()} className='menu-icon-container'>
              {this.getSvg(svgProps)}
            </div>
            <BreadCrumb {...props} />
          </div>
          <div className='search-bar-container'>
            <div className="version">{props.i18n.version}</div>
            <div className="searchBarWrapper fa fa-search">
              <input type="text" className="searchBar" onChange={props.onSearch} />
            </div>
          </div>
          <div className="treemenu" onClick={this.onMobileTreeMenuClick.bind(this)}>
            <i className='treemenu-icon fa' data-isshow={props.mobileMenuIsShow}></i>
          </div>
        </div>
      </div>
    )
  }

  render() {
    //append language option
    let lang = this.props.lang || "en-US";
    var logo = window.content_path + 'images/logo.' + lang + '.png';
    let svgProps = {
      color: 'currentColor',
      size: 32,
      height: '100%',
      width: '100%',
      kind: this.props.menuIsShow ? 'collapse' : 'expand'
    };

    this.getVersionInfo(this.props);
    if (lang == "zh-CN") {
      return this.TopBarCN(lang, logo, svgProps)
    }
    return this.TopBarMescius(lang, logo, svgProps)
  }
}

class BreadCrumb extends Component {
  constructor(props) {
      super(props);
      this._paths = [];
  }

  resolveProps() {
      this._paths = Util.FindAncestorNodes(this.props.treeData, this.props.currentPage, this.props.i18n.home);
  }

  shouldComponentUpdate(nextProps) {
      return this.props.currentPage != nextProps.currentPage
  }

  render() {
      this.resolveProps();
      let c = [];
      this._paths.forEach((node, index) => {
          c.push(this.renderItem(node, index));
          let split = this.renderSplit(index);
          if (split) {
              c.push(split);
          }
      });
      return (
          <div className='nav-flex'>
              <div className='nav-flex nav-flex-middle nav-breadcrumb'>{c}</div>
              <div className='nav-flex nav-flex-middle nav-home'>
                  <div className='nav-path' data-index='0' onClick={this.onClick.bind(this)} >{this.props.i18n.home}</div>
              </div>
          </div>)
  }

  renderItem(node, index) {
      return <div className='nav-path' data-index={index} onClick={this.onClick.bind(this)} >{node.name}</div>
  }

  renderSplit(index) {
      if (index < this._paths.length - 1) {
          return <div className='nav-split'><i className="fa fa-chevron-right"></i></div>;
      }
  }

  onClick(e) {
      let index = Number((e.target).dataset.index);
      if (index == 0) {
          this.props.onClickHome();
      }
      else {
          this.props.onToggleClick(this._paths[index], false);
      }
  }
}

export default withRouter(TopBar);
